import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { navigationService } from 'vue-spatialnavigation';
import { qrCodeImageUrl, displayUrl } from '@/helpers/qr-code';
import TG4Button from '@/components/TG4Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCodeModal',
  props: {
    url: null,
    title: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  url: string;
  title?: string;
};






const codeImageUrl = computed(() => qrCodeImageUrl(props.url));

const showCode = ref(true);

const codeDidFailToLoad = () => {
  showCode.value = false;
};

onMounted(() => {
  setTimeout(() => {
    const element = navigationService.getFocusElementById('qr-modal-close');
    if (element) element.focus();
  }, 200);
});

return { __sfc: true,props, emit, codeImageUrl, showCode, codeDidFailToLoad, displayUrl, TG4Button }
}

})